"use client";

import { CandidateLogoBase, type CandidateLogoBaseProps } from "./candidate-logo-base";

export type EducationLogoProps = Omit<
  CandidateLogoBaseProps,
  "fallbackIcon" | "fallbackLabel"
>;

export function EducationLogo(props: EducationLogoProps) {
  return (
    <CandidateLogoBase
      fallbackIcon="IconGraduateCap"
      fallbackLabel="School logo"
      {...props}
    />
  );
}
